module.exports = __webpack_public_path__ + "img/03.30337336.png";